import { Action } from '@ngrx/store';
import { Invoice } from 'src/app/models/invoice.model';

export const LOAD_INVOICES = '[Invoices] Load Invoices';
export const LOAD_INVOICES_FAIL = '[Invoices] Load Invoices Fail';
export const LOAD_INVOICES_SUCCESS = '[Invoices] Load Invoices Success';
export const CLEAR_INVOICES = '[Invoices] Clear Invoices';

export class LoadInvoices implements Action {
  readonly type = LOAD_INVOICES;
}

export class LoadInvoicesFail implements Action {
  readonly type = LOAD_INVOICES_FAIL;
  constructor(public payload: any) {}
}

export class LoadInvoicesSuccess implements Action {
  readonly type = LOAD_INVOICES_SUCCESS;
  constructor(public payload: Invoice[]) {}
}

export class ClearInvoices implements Action {
  readonly type = CLEAR_INVOICES;
}

// action types
export type InvoicesAction =
  | LoadInvoices
  | LoadInvoicesFail
  | LoadInvoicesSuccess
  | ClearInvoices;
